import axios from 'axios'
import { Message, Loading } from 'element-ui'
import { getToken, removeToken } from '@/utils/cookies'
import { LazycatAccountCenter } from '@lazycatcloud/public-account'
import store from '@/store'

const defaults = {
  custom: false, // 是否直接返回Response
  noErrorMsg: false, // 不显示后台返回错误msg
  loading: false, // 是否显示全屏loading
}

let isJumpLoginIng = false

let baseURL = process.env.VUE_APP_BASE_API_URL_V3 + "/admin"
// let baseURL = '/api/v2/admin'

const service = axios.create({
  baseURL: baseURL,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 * 600, // request timeout
})

let reqNum = 0
let loading = { close: () => { } }
function startLoading() {
  if (reqNum === 0) {
    loading = Loading.service({
      fullscreen: true,
      lock: true,
      text: '请稍等，正在加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0,0,0,0.7)',
    })
  }

  reqNum++
}

function closeLoading() {
  if (reqNum <= 0) {
    return
  }

  reqNum--

  if (reqNum === 0) {
    loading.close()
  }
}

function endLoading() {
  setTimeout(closeLoading, 300)
}

// request interceptor
service.interceptors.request.use(
  (config) => {

    if (config.url.startsWith("/cms")) {
      config.baseURL = process.env.VUE_APP_BASE_API_URL
    }

    if (config.url.startsWith("/api/comment")) {
      config.baseURL = "/"
      // config.baseURL = `${baseHost}/`
    }


    if (getToken()) {
      config.headers['X-User-Token'] = getToken()
      console.log(getToken());
      
    }
    // config.headers["X-User-Token"] = 

    config = Object.assign({}, defaults, config)

    if (config.loading) {
      startLoading()
    }

    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  },
)

// response interceptor
service.interceptors.response.use(
  async (response) => {
    const res = response.data
    const config = response.config
    const notJSON =
      response.headers['content-type'] &&
      response.headers['content-type'].indexOf('json') === -1

    if (config.loading) {
      endLoading()
    }

    return { data: res }

    // if (config.custom || notJSON) {
    //   return response
    // }

    // if (!config.noErrorMsg && !res.success) {
    //   let msg = res.msg || res.message || 'Error'
    //
    //   if (response.request.responseType === 'blob') {
    //     const data = await readAsDataText(res)
    //     msg = data.msg || res.message || 'Error'
    //   }
    //
    //   Message.error({
    //     message: `<pre>${msg}</pre>`,
    //     type: 'error',
    //     duration: 2000,
    //     dangerouslyUseHTMLString: true,
    //   })
    //
    //   return Promise.reject(new Error(msg))

  },
  (error) => {
    endLoading()

    if (error.response.status === 401 && !isJumpLoginIng) {
      isJumpLoginIng = true

      Message({
        message: '登录态失效，请重新登录',
        type: 'error',
        duration: 2000,
        onClose: () => {
          LazycatAccountCenter.ClearToken()
          removeToken()
          this.$router.replace(`/login`)
        },
      })

      return Promise.reject(error)
    }

    if (error.response.status === 304) {
      Message({
        message: error.response.data || '状态无改变',
        type: 'success',
        duration: 2000,
      })
      return Promise.reject(error)
    }

    // const msg = error.response.data && error.response.data.message
    //
    Message({
      message: error.response.data || '当前服务器忙，请稍后再试。',
      type: 'error',
      duration: 2000,
    })

    return Promise.reject(error)
  },
)

const readAsDataText = (file) => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onerror = reject
    fr.onload = function() {
      resolve(JSON.parse(fr.result))
    }
    fr.readAsText(file, 'utf-8')
  })
}

export default service
